// themes/js/modules/magazyn-qr.js
// FixSystem 2.0 - Magazyn QR (ES6 Module)
// Używa dynamic loadera: import ensureQRCode from "./qrcode.js"
import ensureQRCode from "./qrcode.js";

// Generowanie QR w elemencie
export async function generateQRCode(elementId, text, size = 200) {
    const QRCode = await ensureQRCode();
    const element = document.getElementById(elementId);
    if (!element) return;

    element.innerHTML = "";

    new QRCode(element, {
        text,
        width: size,
        height: size,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.M
    });
}

// Drukowanie etykiety QR
export async function printQRLabel(kodQR, nazwa, numerSeryjny) {
    const printWindow = window.open("", "_blank", "width=400,height=300");

    printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>Etykieta QR</title>
            <style>
                body { font-family: Arial, sans-serif; margin: 0; padding: 10px; text-align: center; }
                .label { border: 2px dashed #ccc; padding: 15px; display: inline-block; width: 250px; }
                .qr-container { margin: 10px auto; }
                .nazwa { font-size: 12px; font-weight: bold; margin: 10px 0 5px; word-wrap: break-word; }
                .sn { font-size: 10px; color: #666; margin-bottom: 5px; }
                .kod { font-family: monospace; font-size: 14px; font-weight: bold; letter-spacing: 1px; }
                .odzysk-badge { background: #ff9800; color: white; padding: 2px 8px; border-radius: 10px; font-size: 10px; display: inline-block; margin-bottom: 5px; }
                @media print { body { margin: 0; } .label { border: 1px solid #000; } }
            </style>
        </head>
        <body>
            <div class="label">
                <div class="odzysk-badge">♻ ODZYSK</div>
                <div class="qr-container" id="qr"></div>
                <div class="nazwa">${nazwa}</div>
                ${numerSeryjny ? `<div class="sn">S/N: ${numerSeryjny}</div>` : ""}
                <div class="kod">${kodQR}</div>
            </div>
        </body>
        </html>
    `);

    printWindow.document.close();

    // Wstrzyknięcie qrcode.min.js do okna drukowania
    const script = printWindow.document.createElement("script");
    script.src = "/themes/js/qrcode.min.js";
    script.onload = () => {
        const QR = printWindow.QRCode;
        new QR(printWindow.document.getElementById("qr"), {
            text: kodQR,
            width: 120,
            height: 120,
            correctLevel: QR.CorrectLevel.M
        });
        setTimeout(() => printWindow.print(), 500);
    };
    printWindow.document.head.appendChild(script);
}
